import React, { useState } from 'react'
import PhoneInput from '../../../components/common/PhoneInput'

const StepPhoneInput = ({ onNext, data }) => {
  const [error, setError] = useState()
  const [formData, setFormData] = useState({
    phoneNumber: data?.phone || '',
  })

  const phoneNumberValidationError = () => {
    const phone = formData.phoneNumber
    if (phone.length < 13) {
      return 'Phone number must be at least 13 characters long'
    }
    if (phone.substring(0, 3) !== '+25') {
      return 'Phone number must start with +25'
    }
    return null
  }

  const handleNext = () => {
    const phone = formData.phoneNumber
    if (!phone) {
      setError('Phone number is required')
      return
    }

    const validationError = phoneNumberValidationError()
    if (validationError) {
      setError(validationError)
      return
    }

    onNext({ phone })
  }

  return (
    <div className="flex flex-col items-center gap-5">
      <div>
        <h2 className="w-full text-[32px] font-extrabold text-black text-center">
          Account Verification
        </h2>
      </div>
      <div className="w-full mt-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Enter Your Phone Number <span className="text-red-500">*</span>
        </label>
        <PhoneInput
          id="phoneNumber"
          value={formData.phoneNumber}
          onChange={(phone) => setFormData({ ...formData, phoneNumber: phone })}
        />
        {error && <span className="text-red-500 text-[14px] font-medium">{error}</span>}
      </div>
      <button
        className="w-[90%] max-w-[324px] h-[55px] bg-gradient-to-r from-[#DE8516] to-[#F08A0A] shadow-md rounded-[10px] text-white text-[18px] font-medium font-inter capitalize mt-8"
        style={{ boxShadow: '0px 4px 4px rgba(0,0,0,0.25)' }}
        onClick={handleNext}
      >
        NEXT
      </button>
    </div>
  )
}

export default StepPhoneInput
